"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const translationsApi_1 = require("../api/translationsApi");
const cache_1 = require("../cache");
const cacheValidation_1 = require("../cache/cacheValidation");
const model_1 = require("../cache/model");
exports.addMultiDimensionsToParam = (translationParam, config) => {
    const { multiDimensions: { brand, country, region, language } } = config;
    return `${translationParam}-${brand}-${language}-${country}-${region}`;
};
const TRANSLATIONS_EXPIRATION_TIME = 60;
const apiRepo = {
    get: (forComponentType, config) => {
        return translationsApi_1.translationsApi.translations(forComponentType, config).then((data) => {
            const trsObj = data.data;
            const cacheEntry = {
                data: trsObj,
                createdAt: new Date().getTime(),
                expiresAt: new Date().getTime() + (TRANSLATIONS_EXPIRATION_TIME * 60000),
            };
            cacheRepo.setData(forComponentType, cacheEntry, config);
            return trsObj;
        });
    }
};
const cacheRepo = {
    get: (translationParam, config) => {
        const paramWithMultiDimensions = exports.addMultiDimensionsToParam(translationParam, config);
        return cache_1.getCacheInstance(model_1.CacheType.TRANSLATIONS).getItem(paramWithMultiDimensions);
    },
    setData: (translationParam, data, config) => {
        const paramWithMultiDimensions = exports.addMultiDimensionsToParam(translationParam, config);
        return cache_1.getCacheInstance(model_1.CacheType.TRANSLATIONS).setItem(paramWithMultiDimensions, data);
    },
};
exports.translations = (translationParam, config) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const paramWithMultiDimensions = exports.addMultiDimensionsToParam(translationParam, config);
        const isValid = yield cacheValidation_1.isCacheValid(model_1.CacheType.TRANSLATIONS, paramWithMultiDimensions);
        const trs = yield (isValid ? cacheRepo.get(translationParam, config) : apiRepo.get(translationParam, config));
        return trs.data ? trs.data : trs;
    }
    catch (e) {
        console.error(e);
    }
});
//# sourceMappingURL=translations.js.map